namespace Indexes {
    export class Purchase
    implements StaticIndexDefinition {

        name = "PurchaseAll";
        maps = [
            "from u in docs.Purchases select new { u.name, u.description }"
        ];
    }
}